import './EventRibbon.css';

/**
 * EventRibbon Component
 * Displays active learning day event banner matching mockUI.html
 */
const EventRibbon = ({ title = 'Learning Day', date = '' }) => {
  return (
    <div className="date-ribbon">
      <span className="ribbon-text">{title} {date}</span>
    </div>
  );
};

export default EventRibbon;
